<template>
  <v-chart ref="vgraph" :autoresize="true" :manual-update="true" />
</template>

<script>
import Vue from "vue";
import ECharts from "vue-echarts";
import VueCompositionAPI from "@vue/composition-api";
import * as echarts from "echarts/core";
import { CanvasRenderer } from "echarts/renderers";
import { BarChart, LineChart } from "echarts/charts";
import {
  DatasetComponent,
  GridComponent,
  TooltipComponent,
  LegendComponent,
} from "echarts/components";
import { echartformat } from "../../../functions/general-functions";
Vue.use(VueCompositionAPI);
echarts.use([
  BarChart,
  LineChart,
  DatasetComponent,
  GridComponent,
  TooltipComponent,
  LegendComponent,
  CanvasRenderer,
]);
const colors = [
  "#0071BC",
  "#39B54A",
  "#F7931E",
  "#ED1C24",
  "#93278F",
  "#ED1E79",
];
export default {
  components: { "v-chart": ECharts },
  props: {
    type: String,
    isVaccination: Boolean,
  },
  mounted: function () {
    let ser = this.type == "day" ? [2, 4] : [1, 3, 5];
    if (this.isVaccination) {
      ser = this.type == "day" ? [2, 4] : [1, 3];
    }
    const graphType = this.type == "day" ? "bar" : "line";
    const _self = this;
    this.graphData = {
      color: colors,
      title: {
        show: false,
      },
      textStyle: {
        fontFamily: '"Montserrat", Helvetica, Arial, sans-serif',
      },
      dataset: {
        source: this.isVaccination
          ? window.vaccinationGraphData
          : window.graphData,
      },
      legend: {
        show: true,
      },
      tooltip: {
        trigger: "axis",
        formatter: function (vv) {
          var tt = "";
          tt = tt.concat(vv[0].name, "<br/>");
          vv.forEach(function (v) {
            var valData = v.value[v.seriesIndex * 2 + ser[0]];
            if (valData) {
              var val = echartformat(
                v.value[v.seriesIndex * 2 + ser[0]],
                "decimal",
                0
              );
              tt = tt.concat(v.marker, v.seriesName, ": ", val, "<br/>");
            }
          });
          return tt;
        },
      },
      grid: {
        right: 40,
        left: 80,
        top: 40,
        bottom: 20,
      },
      xAxis: {
        type: "category",
        inverse: true,
      },
      yAxis: {
        axisLabel: {
          formatter: function (vv) {
            return echartformat(vv, "decimal", 0);
          },
        },
      },
      series: ser.map((q) => {
        return {
          type: graphType,
          connectNulls: true,
          encode: {
            seriesName: [q],
            x: 0,
            y: q,
          },
        };
      }),
    };
    setTimeout(() => {
      _self.$refs.vgraph.setOption(_self.graphData, true, true);
    }, 500);
  },
};
</script>